module.exports = __webpack_public_path__ + "mastercard-icon@2x.png?d4e5cb6f59791d0b7e7622c69e79d724";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mastercard-icon@2x.png
// module id = 1041
// module chunks = 0